import { types } from '@jbrowse/mobx-state-tree'

import {
  defaultDrawLabels,
  defaultDrawNodeBubbles,
  defaultDrawTree,
  defaultLabelsAlignRight,
  defaultShowBranchLen,
  defaultTreeAreaWidth,
  defaultTreeWidth,
} from '../constants.ts'

/**
 * #stateModel Tree
 */
export function TreeModelF() {
  return types
    .model({
      /**
       * #property
       */
      drawLabels: types.stripDefault(types.boolean, defaultDrawLabels),
      /**
       * #property
       * right-align the labels
       */
      labelsAlignRight: types.stripDefault(
        types.boolean,
        defaultLabelsAlignRight,
      ),

      /**
       * #property
       * width of the area the tree is drawn in, px
       */
      treeAreaWidth: types.stripDefault(types.number, defaultTreeAreaWidth),

      /**
       * #property
       * width of the tree within the treeArea, px. automatically synced to
       * fit within treeAreaWidth
       */
      treeWidth: types.stripDefault(types.number, defaultTreeWidth),

      /**
       * #property
       * use "branch length" e.g. evolutionary distance to draw tree branch
       * lengths. if false, the layout is a "cladogram" that does not take into
       * account evolutionary distances
       */
      showBranchLen: types.stripDefault(types.boolean, defaultShowBranchLen),

      /**
       * #property
       * draw tree, boolean
       */
      drawTree: types.stripDefault(types.boolean, defaultDrawTree),

      /**
       * #property
       * draw clickable node bubbles on the tree
       */
      drawNodeBubbles: types.stripDefault(
        types.boolean,
        defaultDrawNodeBubbles,
      ),

      /**
       * #property
       * auto-size treeAreaWidth to fit the row labels (plus the tree, if drawn)
       * instead of using a fixed width. useful when there is no tree, so the
       * label gutter isn't padded out to the default 400px
       */
      autoTreeAreaWidth: types.stripDefault(types.boolean, false),
    })
    .actions(self => ({
      /**
       * #action
       * set tree area width (px)
       */
      setTreeAreaWidth(n: number) {
        self.treeAreaWidth = Math.round(n)
      },
      /**
       * #action
       * set tree width (px)
       */
      setTreeWidth(n: number) {
        self.treeWidth = Math.round(n)
      },

      /**
       * #action
       */
      setLabelsAlignRight(arg: boolean) {
        self.labelsAlignRight = arg
      },
      /**
       * #action
       */
      setDrawTree(arg: boolean) {
        self.drawTree = arg
      },
      /**
       * #action
       */
      setAutoTreeAreaWidth(arg: boolean) {
        self.autoTreeAreaWidth = arg
      },

      /**
       * #action
       */
      setShowBranchLen(arg: boolean) {
        self.showBranchLen = arg
      },

      /**
       * #action
       */
      setDrawNodeBubbles(arg: boolean) {
        self.drawNodeBubbles = arg
      },
      /**
       * #action
       */
      setDrawLabels(arg: boolean) {
        self.drawLabels = arg
      },
    }))
}
